import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import useGameStore from '../../store/gameStore';
import { Map, ChevronRight } from 'lucide-react';
import { FLAG_TYPE_COLORS } from '../developpement/CarteReseau';
import {
  VILLES, NB_TYPES_MAGASIN, magasinsParVille, statutVille, STATUTS_VILLE,
  nbMagasins, bonusReseauGeo,
} from '../../utils/villes';
import { getTypeMagasin } from '../../utils/ouverture';

/* Dashboard — synthèse compacte du réseau, cliquable vers /developpement. */
export default function ReseauCard() {
  const retail = useGameStore(s => s.retail);
  const navigate = useNavigate();
  const parVille = useMemo(() => magasinsParVille(retail), [retail]);
  const geo = useMemo(() => bonusReseauGeo(retail), [retail]);
  if (!retail?.magasin) return null;

  const villes = VILLES.filter(v => parVille[v.id]?.length)
    .map(v => ({ v, mags: parVille[v.id] }))
    .sort((a, b) => b.mags.length - a.mags.length)
    .slice(0, 5);

  return (
    <button type="button" onClick={() => navigate('/developpement')}
      className="w-full text-left surface-card bg-card border border-ink-600 rounded-xl p-4 hover:border-accent/50 transition-colors group"
      data-testid="reseau-card">
      <div className="flex items-center gap-2 mb-3">
        <div className="p-1.5 rounded-lg bg-accent/15 text-accent"><Map className="w-4 h-4" /></div>
        <p className="text-sm font-black text-foreground">Mon réseau</p>
        <span className="ml-auto text-[10px] text-slate-500 flex items-center gap-0.5 group-hover:text-accent transition-colors">
          Développement <ChevronRight className="w-3 h-3" />
        </span>
      </div>
      <div className="grid grid-cols-3 gap-2 mb-3">
        {[
          ['Magasins', String(nbMagasins(retail)), 'reseau-card-magasins'],
          ['Villes', `${geo.nbVilles}/${VILLES.length}`, 'reseau-card-villes'],
          ['Bonus réseau', `+${geo.totalPct} %`, 'reseau-card-bonus'],
        ].map(([l, v, tid]) => (
          <div key={tid} className="rounded-lg bg-ink-800/70 border border-ink-600 px-2 py-1.5 text-center" data-testid={tid}>
            <p className="text-[8px] uppercase tracking-wider text-slate-500">{l}</p>
            <p className="text-sm font-black font-mono text-foreground">{v}</p>
          </div>
        ))}
      </div>
      <div className="space-y-1" data-testid="reseau-card-villes-liste">
        {villes.map(({ v, mags }) => {
          const types = [...new Set(mags.map(x => x.magasin.typeId).filter(Boolean))];
          const st = STATUTS_VILLE[statutVille(types.length)];
          return (
            <div key={v.id} className="flex items-center gap-2 text-[11px]">
              <span className="font-bold text-foreground whitespace-nowrap">{v.drapeau} {v.nom}</span>
              <span className="flex gap-1">
                {mags.map(({ magasin: m }, i) => (
                  <span key={m.id || `p${i}`} className="inline-block w-2.5 h-2.5 rounded-full border border-black/40"
                    title={getTypeMagasin(m.typeId)?.nom || 'Magasin'}
                    style={{ background: FLAG_TYPE_COLORS[m.typeId] || '#94A3B8' }} />
                ))}
              </span>
              <span className="ml-auto text-[9px] font-bold whitespace-nowrap" style={{ color: st.couleur }}>
                {st.label}{types.length >= NB_TYPES_MAGASIN ? ' ★' : ''}
              </span>
            </div>
          );
        })}
      </div>
    </button>
  );
}
